import { Helmet } from 'react-helmet';
import {
    Box,
    Typography,
    Rating,
    Radio,
    TextField
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import { ReactComponent as AddRow } from "../../../../assets/icons/addRow.svg";
import { ReactComponent as Nodata } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as Calendar } from "../../../../assets/icons/calendar.svg";
import { ReactComponent as ClickStart } from "../../../../assets/icons/clickStart.svg";
import { useParams } from "react-router-dom";
import { useFormik, Formik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import emty from "../../../../assets/images/emty.png";

const styles = {
    emty: {
        display: "flex",
        "flex-flow": "column wrap",
        "justify-content": "center",
        "align-items": "center",
        marginBottom: "30px"
    },
};
const IndividualTab = (props) => {
    const _ = require('lodash');
    let { loRow, value, statusEdit, callBack, editor, submitError, actSave, checkeNextAction } = props
    const { t, i18n } = useTranslation();
    const [individual, setIndividual] = React.useState({ detail: [], });
    const [update, setUpdate] = React.useState(false);
    const [status, setStatus] = React.useState("");
    const [comment, setComment] = React.useState("");
    const [workflow_section, setWorkflow_section] = React.useState("");
    const [dataErrorFormik, setdataErrorFormik] = React.useState({});
    const validationSchema = yup.object(dataErrorFormik);
    const [startDate, setStartDate] = React.useState(null);
    const formik = useFormik({
        initialValues: {
            detail: {},
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            // submit(values)
        },
    });

    useEffect(() => {
        if (statusEdit === false) {
            setStatus("")
            setComment("")
            setStartDate(null)
        } else {
            if (Util.formatData(loRow, []).length > 0) {
                setStatus(loRow[0]?.result)
                setComment(loRow[0]?.comment)
                if (Util.formatData(loRow[0]?.extend_date, false) === false) {
                    setStartDate(null)
                } else {
                    setStartDate(Util.formatDate(loRow[0]?.extend_date))
                }
            }
        }
    }, [statusEdit]);
    useEffect(() => {
        if (status !== "extend" && statusEdit) {
            setStartDate(null)
        }
    }, [status]);
    // useEffect(() => {
    //     if (statusEdit && editor === "evaluator") {
    //         callBack([{
    //             "result": status,
    //             "comment": comment,
    //             "extend_date": startDate,
    //         }], "probation_result", workflow_section)
    //     }
    // }, [status, comment, startDate]);

    let onSetComment = (val, workflow) => {
        setComment(val)
        if (Util.formatData(workflow, false) !== false) {
            setWorkflow_section(workflow)
        }
        if (statusEdit && editor === "evaluator") {
            callBack([{
                "result": status,
                "comment": val,
                "extend_date": startDate,
            }], "probation_result", workflow)
        }
    }
    const onCheckStartDate = (val, workflow) => {
        setStartDate(Util.formatDate(val))
        if (Util.formatData(workflow, false) !== false) {
            setWorkflow_section(workflow)
        }
        if (statusEdit && editor === "evaluator") {
            callBack([{
                "result": status,
                "comment": comment,
                "extend_date": Util.formatDate(val),
            }], "probation_result", workflow)
        }
    }
    const onSave = (val, workflow) => {
        setStatus(val)
        if (Util.formatData(workflow, false) !== false) {
            setWorkflow_section(workflow)
        }
        if (statusEdit && editor === "evaluator") {
            callBack([{
                "result": val,
                "comment": comment,
                "extend_date": val === "extend" ? startDate : "",
            }], "probation_result", workflow)
        }
    }
    return (
        <Box>
            {Util.formatData(loRow, []).length > 0 ? loRow.map((rs, index) => (
                statusEdit && editor === "evaluator" && index === 0 ?
                    (<Box mt="30px" p="40px" sx={{ backgroundColor: "#FFFFFF", border: "1px solid #E4E4E4", borderRadius: "10px" }}>
                        <Box display="flex"  >
                            <Box display="flex" sx={{ width: "calc(100% - 200px)" }} pr="20px">
                                {i18n.language === "th-TH" ?
                                    <Typography fontSize={20} fontWeight={600} lineHeight="30px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{rs?.duration === "extend" ? "ขยายช่วงเวลาการประเมิน" : `การประเมินครั้งที่ ${loRow.length - index} (` + rs?.name + ")"} </Typography>
                                    :
                                    <Typography fontSize={20} fontWeight={600} lineHeight="30px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{loRow.length - index}{loRow.length - index === 1 ? "st" : loRow.length - index === 2 ? "nd" : loRow.length - index === 3 ? "rd" : "th"} {rs?.duration === "extend" ? "Extension Evaluation" : "Evaluation (" + rs?.name + ")"} </Typography>
                                }
                                {rs?.is_extend ?
                                    <Box sx={{ height: "31px", display: "flex", alignItems: "center", background: "rgba(86, 125, 244, 0.15)", borderRadius: "5px", padding: " 5px 20px", marginLeft: "20px", }}>
                                        <Typography fontSize={14} fontWeight="500" lineHeight="20.93px" color="#567DF4" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.extensionRating')}</Typography>
                                    </Box>
                                    : rs?.is_final ?
                                        <Box sx={{ height: "31px", display: "flex", alignItems: "center", background: "#EFF6F4", borderRadius: "5px", padding: " 5px 20px", marginLeft: "20px", }}>
                                            <Typography fontSize={14} fontWeight="500" lineHeight="20.93px" color="#5DA196" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.finalRating')}</Typography>
                                        </Box>
                                        :
                                        null
                                }
                            </Box>
                            <Box sx={{ ".MuiRating-root": { fontSize: "18px", }, background: Util.formatData(rs?.expected_rating?.serial, false) !== false && Util.formatData(rs?.expected_rating?.value, false) !== false && isNaN(Number(rs?.total_rating)) === false && isNaN(Number(rs?.expected_rating?.value)) === false ? (Number(rs?.total_rating) - Number(rs?.expected_rating?.value)) >= 0 ? "#EFF6F4" : "#FAEFEE" : "#FAFAFA", borderRadius: "10px", width: "200px", justifyContent: "center", alignItems: "center", }} display="flex">
                                <Rating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={1} defaultValue={Util.formatData(rs?.total_rating, 1)} max={1} />
                                <Typography pl="7px" fontSize={20} fontWeight={500} lineHeight="49px" color="#404349" sx={{ "text-transform": "capitalize" }} >{Util.formatData(rs?.total_rating, 0)}</Typography>
                                <Typography pl="7px" fontSize={20} fontWeight={500} lineHeight="49px" color="#404349" sx={{ "text-transform": "capitalize" }} >({Util.formatData(rs?.total_rating_percent, 0)}%)</Typography>
                            </Box>
                        </Box>
                        <Box display="flex" pt="4px">
                            <Box display="flex" sx={{ width: "calc(100% - 200px)" }} pr="20px">
                                <Typography fontSize={18} fontWeight={500} lineHeight="27px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.result')} <span style={{ color: "#CC6058", fontWeight: "500", fontSize: "16px" }}> *</span></Typography>
                            </Box>
                            {Util.formatData(rs?.expected_rating?.serial, false) !== false ?
                                <Box pt="3px" sx={{ ".MuiRating-root": { fontSize: "13px", }, width: "200px", justifyContent: "center", height: "max-content", alignItems: "center", }} display="flex">
                                    <Typography pr="7px" fontSize={13} fontWeight={400} lineHeight="20px" color="#AAAAAA" sx={{ "text-transform": "capitalize" }} >{t('evaluation.expectedScore')}:</Typography>
                                    <Rating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={1} defaultValue={Util.formatData(rs?.expected_rating?.value, 0)} max={1} />
                                    <Typography pl="7px" fontSize={13} fontWeight={400} lineHeight="20px" color="#AAAAAA" sx={{ "text-transform": "capitalize" }} >{Util.formatData(rs?.expected_rating?.value, 0)}</Typography>
                                </Box>
                                :
                                null}
                        </Box>
                        <Box pt="10px" sx={{ ".MuiRadio-root": { p: "0", "svg": { fontSize: "21.6px" } } }}>
                            <Box display="flex">
                                <Radio name="radio" value="1" size="small" checked={status === "pass"} onChange={() => onSave("pass", rs?.workflow_section?.serial)} />
                                <Typography pl="10px" fontSize={18} fontWeight={400} lineHeight="27px" color="#404349" sx={{}} >{rs?.is_extend || rs?.is_final ? t('evaluation.passProbation') : t('evaluation.continueProbation')}</Typography>
                            </Box>
                            <Box display="flex" pt="10px">
                                <Radio name="radio" value="1" size="small" checked={status === "not_pass"} onChange={() => onSave("not_pass", rs?.workflow_section?.serial)} />
                                <Typography pl="10px" fontSize={18} fontWeight={400} lineHeight="27px" color="#404349" sx={{}} >{t('evaluation.notPassProbation')}</Typography>
                            </Box>
                            {rs?.is_final ?
                                <Box display="flex" pt="10px">
                                    <Radio name="radio" value="1" size="small" checked={status === "extend"} onChange={() => onSave("extend", rs?.workflow_section?.serial)} />
                                    <Typography pl="10px" fontSize={18} fontWeight={400} lineHeight="27px" color="#404349" sx={{}} >{t('evaluation.extendProbabtionPeriod')}</Typography>
                                </Box>
                                :
                                null
                            }
                            {status === "extend" ?
                                <Box display="flex" pt="10px" alignItems="center" sx={{ ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { maxWidth: "250px" }, '& div > div > input': { height: '7px', }, position: "relative" }}>
                                    <Typography pl="10px" ml="21.59px" pr="20px" fontSize={18} fontWeight={400} lineHeight="27px" color="#404349" sx={{}} >{t('label.to')}</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} >
                                        <DatePicker
                                            slots={{
                                                OpenPickerIcon: Calendar
                                            }}
                                            format="dd/MM/yyyy"
                                            value={startDate}
                                            onChange={(newValue) => {
                                                onCheckStartDate(newValue, rs?.workflow_section?.serial)
                                            }}
                                            // minDate={item.validator.min_date !== undefined && item.validator.min_date !== null && item.validator.min_date !== "" ? formik.values[item.validator.min_date] !== undefined && formik.values[item.validator.min_date] !== null && formik.values[item.validator.min_date] !== "" ? new Date(formik.values[item.validator.min_date]) : null : null}
                                            // maxDate={item.validator.max_date !== undefined && item.validator.max_date !== null && item.validator.max_date !== "" ? formik.values[item.validator.max_date] !== undefined && formik.values[item.validator.max_date] !== null && formik.values[item.validator.max_date] !== "" ? new Date(formik.values[item.validator.max_date]) : null : null}
                                            inputProps={{
                                                placeholder: t('admin.announcement.form.selectDate'), readOnly: true, sx: {
                                                    "&::placeholder": {
                                                        opacity: "1",
                                                        color: "#C4C4C4",
                                                        fontWeight: "300",
                                                    }
                                                }
                                            }}
                                            renderInput={(params) => <TextField {...params}
                                                fullWidth
                                                sx={{ ".MuiOutlinedInput-root": { color: "#404349", } }}
                                            />
                                            }
                                        />
                                    </LocalizationProvider>
                                </Box>
                                :
                                null
                            }
                        </Box>
                        <Box pt="20px">
                            <Typography fontSize={18} fontWeight={500} lineHeight="27px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.evaluatorComment')}</Typography>
                        </Box>
                        <Box pt="10px">
                            <TextField
                                fullWidth
                                name="evaluator_comment"
                                placeholder={t('evaluation.enterYourEvaluatorComment')}
                                onChange={e => onSetComment(e.target.value, rs?.workflow_section?.serial)}
                                value={comment}
                                variant="outlined"
                                inputProps={{
                                    sx: {
                                        "&::placeholder": {
                                            opacity: "1",
                                            color: "#C4C4C4",
                                            fontWeight: "300",
                                        }
                                    }
                                }}
                                multiline
                                rows={3}
                                helperText={status !== "not_pass" ? false : actSave && Util.formatData(comment, false) === false ? t('evaluation.pleaseSelectThisField') : ""}
                                error={status !== "not_pass" ? false : actSave && Util.formatData(comment, false) === false}
                            />
                        </Box>
                    </Box>)
                    :
                    (< Box mt="30px" p="40px" sx={{ backgroundColor: "#FFFFFF", border: "1px solid #E4E4E4", borderRadius: "10px" }}>
                        <Box display="flex"  >
                            <Box display="flex" sx={{ width: "calc(100% - 200px)" }} pr="20px">
                                {i18n.language === "th-TH" ?
                                    <Typography fontSize={20} fontWeight={600} lineHeight="30px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{rs?.duration === "extend" ? "ขยายช่วงเวลาการประเมิน" : `การประเมินครั้งที่ ${loRow.length - index} (` + rs?.name + ")"} </Typography>
                                    :
                                    <Typography fontSize={20} fontWeight={600} lineHeight="30px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{loRow.length - index}{loRow.length - index === 1 ? "st" : loRow.length - index === 2 ? "nd" : loRow.length - index === 3 ? "rd" : "th"} {rs?.duration === "extend" ? "Extension Evaluation" : "Evaluation (" + rs?.name + ")"} </Typography>
                                }
                                {rs?.is_extend ?
                                    <Box sx={{ height: "31px", display: "flex", alignItems: "center", background: "rgba(86, 125, 244, 0.15)", borderRadius: "5px", padding: " 5px 20px", marginLeft: "20px", }}>
                                        <Typography fontSize={14} fontWeight="500" lineHeight="20.93px" color="#567DF4" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.extensionRating')}</Typography>
                                    </Box>
                                    : rs?.is_final ?
                                        <Box sx={{ height: "31px", display: "flex", alignItems: "center", background: "#EFF6F4", borderRadius: "5px", padding: " 5px 20px", marginLeft: "20px", }}>
                                            <Typography fontSize={14} fontWeight="500" lineHeight="20.93px" color="#5DA196" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.finalRating')}</Typography>
                                        </Box>
                                        :
                                        null
                                }
                            </Box>
                            <Box sx={{ ".MuiRating-root": { fontSize: "18px", }, background: Util.formatData(rs?.expected_rating?.serial, false) !== false && Util.formatData(rs?.expected_rating?.value, false) !== false && isNaN(Number(rs?.total_rating)) === false && isNaN(Number(rs?.expected_rating?.value)) === false ? (Number(rs?.total_rating) - Number(rs?.expected_rating?.value)) >= 0 ? "#EFF6F4" : "#FAEFEE" : "#FAFAFA", borderRadius: "10px", width: "200px", justifyContent: "center", alignItems: "center", }} display="flex">
                                <Rating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={1} defaultValue={Util.formatData(rs?.total_rating, 1)} max={1} />
                                <Typography pl="7px" fontSize={20} fontWeight={500} lineHeight="49px" color="#404349" sx={{ "text-transform": "capitalize" }} >{Util.formatData(rs?.total_rating, 0)}</Typography>
                                <Typography pl="7px" fontSize={20} fontWeight={500} lineHeight="49px" color="#404349" sx={{ "text-transform": "capitalize" }} >({Util.formatData(rs?.total_rating_percent, 0)}%)</Typography>
                            </Box>
                        </Box>
                        <Box display="flex" pt="4px">
                            <Box display="flex" sx={{ width: "calc(100% - 200px)" }} pr="20px">
                                <Typography fontSize={18} fontWeight={500} lineHeight="27px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.result')} <span style={{ color: "#CC6058", fontWeight: "500", fontSize: "16px" }}> *</span></Typography>
                            </Box>
                            {Util.formatData(rs?.expected_rating?.serial, false) !== false ?
                                <Box pt="3px" sx={{ ".MuiRating-root": { fontSize: "13px", }, width: "200px", justifyContent: "center", height: "max-content", alignItems: "center", }} display="flex">
                                    <Typography pr="7px" fontSize={13} fontWeight={400} lineHeight="20px" color="#AAAAAA" sx={{ "text-transform": "capitalize" }} >{t('evaluation.expectedScore')}:</Typography>
                                    <Rating fontSize={19} sx={{ root: styles.emptyStar }} readOnly name="customized-10" precision={1} defaultValue={Util.formatData(rs?.expected_rating?.value, 0)} max={1} />
                                    <Typography pl="7px" fontSize={13} fontWeight={400} lineHeight="20px" color="#AAAAAA" sx={{ "text-transform": "capitalize" }} >{Util.formatData(rs?.expected_rating?.value, 0)}</Typography>
                                </Box>
                                :
                                null}
                        </Box>
                        <Box pt="10px" sx={{ ".MuiRadio-root": { p: "0", "svg": { fontSize: "21.6px" } } }}>
                            {rs?.is_extend || rs?.is_final ? rs?.result === "pass" || rs?.result === "not_pass" || rs?.result === "extend" ?
                                <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#567DF4" sx={{}} >{rs?.is_extend || rs?.is_final ? rs?.result === "pass" ? t('evaluation.passProbation') : rs?.result === "not_pass" ? t('evaluation.notPassProbation') : rs?.result === "extend" ? t('evaluation.extendProbabtionPeriod') : t('evaluation.notEvaluatedYet') : rs?.result === "pass" ? t('evaluation.continueProbation') : rs?.result === "not_pass" ? t('evaluation.notPassProbation') : rs?.result === "extend" ? t('evaluation.extendProbabtionPeriod') : t('evaluation.notEvaluatedYet')}</Typography>
                                :
                                <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#C4C4C4" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.notEvaluatedYet')}</Typography>
                                : rs?.result === "pass" || rs?.result === "not_pass" || rs?.result === "extend" ?
                                    <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#567DF4" sx={{}} >{rs?.is_extend || rs?.is_final ? rs?.result === "pass" ? t('evaluation.passProbation') : rs?.result === "not_pass" ? t('evaluation.notPassProbation') : rs?.result === "extend" ? t('evaluation.extendProbabtionPeriod') : t('evaluation.notEvaluatedYet') : rs?.result === "pass" ? t('evaluation.continueProbation') : rs?.result === "not_pass" ? t('evaluation.notPassProbation') : rs?.result === "extend" ? t('evaluation.extendProbabtionPeriod') : t('evaluation.notEvaluatedYet')}</Typography>
                                    :
                                    <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#C4C4C4" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.notEvaluatedYet')}</Typography>
                            }
                            {rs?.result === "extend" ?
                                <Box display="flex" pt="10px" alignItems="center" sx={{ ".MuiButtonBase-root": { "justify-content": "flex-end", position: "absolute", width: "100%", height: "100%", left: "0", "border-radius": "unset" }, ".MuiFormControl-root": { maxWidth: "250px" }, '& div > div > input': { height: '7px', }, position: "relative" }}>
                                    <Typography pr="20px" fontSize={18} fontWeight={400} lineHeight="27px" color="#404349" sx={{}} >{t('label.to')}</Typography>
                                    <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#567DF4" >{Util.formatDate2(rs?.extend_date)}</Typography>
                                </Box>
                                :
                                null
                            }
                        </Box>
                        <Box pt="20px">
                            <Typography fontSize={18} fontWeight={500} lineHeight="27px" color="#404349" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.evaluatorComment')}</Typography>
                        </Box>
                        <Box pt="10px">
                            {Util.formatData(rs?.comment, false) !== false ?
                                <Typography fontSize={16} fontWeight={400} lineHeight="23.92px" color="#888F9D" sx={{ wordBreak: "break-all" }}  >{rs?.comment}</Typography>
                                :
                                <Typography fontSize={18} fontWeight={400} lineHeight="27px" color="#C4C4C4" sx={{ overflow: "hidden", textOverflow: "ellipsis", }}>{t('evaluation.notCommentedYet')}</Typography>
                            }
                        </Box>
                    </Box>)
            ))
                :
                <Box sx={{ display: "flex", "flex-flow": "column wrap", "background-color": "#fff", height: "400px", "box-shadow": "0px 0px 5px rgb(0 0 0 / 10%)", "border-radius": "10px", "justify-content": "center", "align-items": "center", }} mt={3} >
                    {/* <Box pt="20px" pb="20px" sx={{ width: "100%", display: "flex", alignItems: "center", flexDirection: "column" }}>
                        <ClickStart />
                        <Typography pt="20px" fontSize={18} lineHeight="27px" fontWeight="500" color="#AAAAAA">Please click “Start” for evaluation.</Typography>
                    </Box> */}
                    <Box sx={{ "text-align": "center", }}>
                        <Nodata />
                        <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                            {t('label.noData')}
                        </Typography>
                    </Box>
                </Box>
            }
        </Box >
    )
};
export default IndividualTab;
